import React from 'react';
import ReactDOM from 'react-dom/client';
import EVMTools from './EVMTools';
import { StyledEngineProvider } from '@mui/material/styles';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <EVMTools />
    </StyledEngineProvider>
  </React.StrictMode>
);